import React from 'react';

const viRotateLeft = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 12"
    style={{
      width: '1em',
      height: '1em',
      overflow: 'visible',
    }}
  >
    <g transform="matrix(-1 0 0 1 12 0)">
      {/* eslint-disable-next-line max-len */}
      <path d="M8.25825 11.4113L8.63325 9.67125C8.67675 9.46875 8.874 9.3435 9.07875 9.38325C9.28125 9.4275 9.4095 9.62625 9.366 9.8295L9.17175 10.7303C10.4768 9.82125 11.25 8.367 11.25 6.75C11.25 6.543 11.418 6.375 11.625 6.375C11.832 6.375 12 6.543 12 6.75C12 8.49375 11.1825 10.1318 9.828 11.187L10.8975 11.2508C11.1045 11.2635 11.262 11.4405 11.2493 11.6475C11.2373 11.8462 11.0723 12 10.875 12C10.8675 12 10.86 12 10.8525 11.9992L8.6025 11.8643C8.493 11.8575 8.3925 11.8043 8.32575 11.7172C8.25975 11.6302 8.235 11.5178 8.25825 11.4113Z" fill="currentColor" />
      {/* eslint-disable-next-line max-len */}
      <path d="M2.17195 0.813L1.10245 0.74925C0.895449 0.7365 0.73795 0.5595 0.7507 0.3525C0.7627 0.15375 0.927699 0 1.12495 0C1.13245 0 1.13995 0 1.14745 0.00075L3.39745 0.13575C3.50695 0.1425 3.60745 0.19575 3.6742 0.28275C3.7402 0.36975 3.76495 0.48225 3.7417 0.58875L3.3667 2.32875C3.3232 2.53125 3.12595 2.6565 2.9212 2.61675C2.7187 2.5725 2.59045 2.37375 2.63395 2.1705L2.82745 1.26975C1.5232 2.17875 0.749949 3.633 0.749949 5.25C0.749949 5.457 0.581949 5.625 0.374949 5.625C0.167949 5.625 -5.10216e-05 5.457 -5.10216e-05 5.25C-5.10216e-05 3.50625 0.817449 1.86825 2.17195 0.813Z" fill="currentColor" />
      {/* eslint-disable-next-line max-len */}
      <path d="M1.22706 6.53019L6.53031 1.22694C6.82281 0.934443 7.29831 0.934443 7.59081 1.22694L10.7731 4.40919C11.0656 4.70169 11.0656 5.17719 10.7731 5.46969L5.46981 10.7729C5.17731 11.0654 4.70181 11.0654 4.40931 10.7729L1.22706 7.59069C0.934557 7.29819 0.934557 6.82269 1.22706 6.53019ZM5.46981 9.71244L9.71256 5.46969L6.53031 2.28744L2.28756 6.53019L5.46981 9.71244Z" fill="currentColor" />
    </g>
  </svg>
);

export default viRotateLeft;
